import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeTableViewColumns } from './normalize';

export const fetchTableViewColumns = createProvider(api.fetchTableViewColumns)
  .andThen((res) => normalizeTableViewColumns(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch table view columns aborted');
    } else {
      console.error('Fetch table view columns was failed:', error);
    }
    throw error;
  });

export const saveTableViewColumns = createProvider(api.saveTableViewColumns).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Save table view columns aborted');
  } else {
    console.error('Save table view columns was failed:', error);
  }
  throw error;
});
